import React from 'react';

import { Outlet } from 'react-router-dom';

import { injectIntl } from 'react-intl';

import { useInjectRedux, REDUX_MODULE } from 'hooks/useRedux';
import SuspenseLoading from 'common/components/loading/SuspendLoading.js';

const { lazy } = React;

const TransitionPageGrid = lazy(() =>
  import('./view/transition-page-grid/TransitionPage.js')
);

const TransitionPageDetail = lazy(() =>
  import('./view/transition-page-detail')
);

export const transitionPageNestedRoutes = [
  {
    index: true,
    element: <TransitionPageGrid />,
  },
  {
    path: 'new',
    element: <TransitionPageDetail />,
  },
  {
    path: ':pageId',
    element: <TransitionPageDetail />,
  },
];

const TransitionPage = () => {
  useInjectRedux(REDUX_MODULE.TRANSITION_PAGE);

  return (
    <SuspenseLoading>
      <Outlet />
    </SuspenseLoading>
  );
};

export default injectIntl(TransitionPage);
